"use strict";exports.f=i=>new Date(i).toLocaleDateString(void 0,{year:"numeric",month:"2-digit",day:"numeric",hour:"2-digit",minute:"2-digit"});